import ViewBase from "../../../../view-base.view";
import { FILE_EXTENSIONS } from "../../../../../config/constants";
import FileUploadInputComponent from "../../../../../components/file/file-upload-input.component";
import paginationComponent from "../../../../../components/pagination/pagination.component";
import fileTemplateModel from "../../../../../models/common/file-template.model"
import campaignModel from "../../../../../models/planogram/campaign.model"
import fileModel from "../../../../../models/common/file.model"
import moment from 'moment'
import { styledMessageComponent, messageType } from "../../../../../components/message/styledMessage.component"
import { Intent } from 'construct-ui';

export default function Step2() {
  ViewBase.call(this);

  const UPLOAD_INPUT_ID = 'fixtureSKUMappingExcelUploadInput';

  const SELECT_ALL_CHECKBOX_ID = "fixtureSKUMappingListSelectAllCheckbox";
  const CHECKBOX_NAME = "fixtureSKUMappingListCheckbox";

  let uploadingFile = null;
  let _campaignId = null;

  let onGoBack = () => { };
  let onGoNext = () => { };

  const DEFAULT_PAGINATION = {
    pageSize: 10,
    pageIndex: 1,
    totalItems: 0,
  };

  let pagination = structuredClone(DEFAULT_PAGINATION);
  let fixtureSKUMappingList = [];
  let selectedFixtureSKUMappingList = [];

  let isMsgOpen = false;
  let deleteActionKey = "";

  const uploadedResult = {
    errorCount: 0,
    successCount: 0,
    fileMasterID: null
  }

  const downloadSKUMapTemplate = () => {
    this.showLoading();
    const File_Name = "Campaign_SKU_Mapping_Template.xlsx"
    const exportConfig = {
      storedProcedureCode: "38",
      params: [
        {
          "code": "66",
          "value": "FixtureSKUMap"
        }
      ],
      excelSheetNames: ["SKU Mapping"]
    };

    fileTemplateModel.downloadExcelTemplate(File_Name, exportConfig)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleUpload = (e) => {
    if (!this.validateForm(e, "#fixtureSKUForm")) {
      return false;
    } else {
      let filesFormData = new FormData();
      filesFormData.append("file", uploadingFile);

      filesFormData.append("campaignId", _campaignId);
      campaignModel.uploadFixtureSKUMap(filesFormData).then((result) => {
        uploadedResult.errorCount = result.errorCount;
        uploadedResult.successCount = result.successCount;
        uploadedResult.fileMasterID = result.fileMasterID;
        fetchFixtureSKUMapList();
      }).catch((error) => {
        this.handleError(error);
      })
    }
  };

  const toQueryParams = (params) => {
    return Object.assign(
      {
        pageSize: pagination.pageSize,
        pageIndex: pagination.pageIndex,
        campaignId: params.campaignId
      }
    );
  };

  const fetchFixtureSKUMapList = () => {
    if (!_campaignId) {
      return;
    }
    uncheckAllCheckboxes();
    this.showLoading();
    const params = {
      campaignId: _campaignId
    }
    campaignModel.getFixtureSKUMapList(toQueryParams(params)).then((result) => {
      fixtureSKUMappingList = result.data;
      pagination.pageIndex = result.pageIndex;
      pagination.pageSize = result.pageSize;
      pagination.totalItems = result.total;
    }).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    })
  }
  const downloadFixtureSKUMap = () => {
    if (!uploadedResult.fileMasterID) {
      return;
    }
    this.showLoading();
    const fileName = `SKU Mapping - ${moment().format('YYYYMMDDHHmm')}`
    const params = {
      fileId: uploadedResult.fileMasterID
    }
    fileModel.downloadByFileIdV2(params, fileName).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    })
  }

  const selectRow = (checked, item) => {
    if (checked) {
      selectedFixtureSKUMappingList.push(item.planogramFixturePositionID);
    } else {
      selectedFixtureSKUMappingList = selectedFixtureSKUMappingList.filter(
        (data) => data !== item.planogramFixturePositionID
      );
    }

    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    if (selectedFixtureSKUMappingList.length === 0) {
      selectAllCheckbox.indeterminate = false;
      selectAllCheckbox.checked = false;
    }
    else {
      selectAllCheckbox.indeterminate = true;
      selectAllCheckbox.checked = false;
    }
  };

  const onCheckAll = (event) => {
    let checkboxes = document.querySelectorAll(
      `input:not([disabled])[type='checkbox'][name='${CHECKBOX_NAME}']`
    );

    selectedFixtureSKUMappingList = [];

    if (event.target.checked || event.target.indeterminate) {
      fixtureSKUMappingList.forEach((item) => {
        // if (item.editable) {
        selectedFixtureSKUMappingList.push(item.planogramFixturePositionID);
        // }
      });

      checkboxes.forEach((item) => {
        item.checked = true;
      });
    } else {
      checkboxes.forEach((item) => {
        item.checked = false;
      });
    }
    event.target.indeterminate = false;
  };

  const uncheckAllCheckboxes = () => {
    const arr = document.querySelectorAll(`input[name=${CHECKBOX_NAME}]`);
    if (arr.length === 0) {
      return;
    }
    arr.forEach((checkbox) => {
      checkbox.checked = false;
    });
    let selectAllCheckbox = document.querySelector(
      `#${SELECT_ALL_CHECKBOX_ID}`
    );
    selectAllCheckbox.indeterminate = false;
    selectAllCheckbox.checked = false;

    selectedFixtureSKUMappingList = [];
  };


  const _initControls = () => {
    this.showLoading();

    Promise.allSettled([
      fetchFixtureSKUMapList()
    ]).finally(() => {
      this.hideLoading();
    });
  };

  const showDeleteDialog = (key) => {
    isMsgOpen = true;
    deleteActionKey = key;
  }

  const handleDelete = () => {
    const params = {
      campaignId: _campaignId
    }
    if (deleteActionKey === 'ALL') {
      if (fixtureSKUMappingList?.length > 0) {
        params.planogramFixturePositionIDs = 'ALL';
        onDeleteAction(params);
      } else {
        this.showErrorMessage(this.getText("LT00001076", "No Data"));
      }
    } else {
      if (selectedFixtureSKUMappingList.length > 0) {
        params.planogramFixturePositionIDs = selectedFixtureSKUMappingList.join('^');
        onDeleteAction(params);
      } else {
        this.showErrorMessage(this.getText("LT00000719", "No items selected"));
      }
    }
  }

  const onDeleteAction = (params) => {
    campaignModel.deleteFixtureSKUMaps(params).then(() => {
      _initControls();
      this.showMessage(this.getText("EM00000004", "Success"));
    }).catch(() => {
      this.showErrorMessage(this.getText("EM00000142", "Error"));
    }).finally(() => {
      _dialogClosed();
    })
  }

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    fetchFixtureSKUMapList();
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    fetchFixtureSKUMapList();
  };

  const _dialogClosed = () => {
    isMsgOpen = false;
  }
  const msgContent = m(".alert.alert-warning.fade.show.mt-2.mb-0", [
    m("h4.alert-heading", "Warning"),
    m(".col-12",
      m("p.fw-bold",
        "Deleting this mapping data may impact the compliance report if there are ongoing mobile compliance activites."
      ),
      m("p.fw-bold",
        "Please proceed with caution."
      ),
    )
  ]);
  const msgTitle = this.getText("LT00001236", "Delete SKU mapping");
  const extraProps = this.getText("EM00000830", "Are you sure you want to delete all data(s)?");
  return {
    oninit: ({ attrs: { onBack, onNext, campaignId } }) => {
      if (onBack) {
        onGoBack = onBack;
      }

      if (onNext) {
        onGoNext = onNext;
      }

      if (campaignId) {
        _campaignId = campaignId
        fetchFixtureSKUMapList()
      }
    },
    view: (vnode) => {
      return [
        m('.row.ms-2',
          m('ol',
            m('li.fw-bold.mb-4',
              m('.mb-2', this.getText('LT00000218', 'Download Template')),
              m('button.btn.btn-primary',
                {
                  onclick: downloadSKUMapTemplate
                },
                m('i.bi.bi-file-earmark-arrow-down-fill'),
                this.getText('LT00000218', 'Download Template')
              ),
            ),
            m('li.fw-bold.mb-4',
              m('.mb-2.mandatory', this.getText('LT00000197', 'Excel Upload')),
              m('form#fixtureSKUForm.row.g-4.needs-validation[novalidate]', { onsubmit: handleUpload },
                m('.col-6.position-relative',
                  m(FileUploadInputComponent, {
                    id: UPLOAD_INPUT_ID,
                    accept: FILE_EXTENSIONS.XLSX,
                    required: true,
                    // requiredInvalidText: this.getText('EM00000316', 'Please select a file'),
                    onInput: (data) => {
                      uploadingFile = data;
                    },
                  }),
                  m('.invalid-tooltip', this.getText('EM00000316', 'Please select a file'))
                ),
                m('.col-2',
                  m('button.btn.btn-primary[type="submit"]', this.getText("LT00000290", "Upload")),
                )
              ),
              uploadedResult?.fileMasterID && m(".alert.alert-info.fade.show.mt-4", [
                m("h4.alert-heading", "For your convenience, please download and check your uploaded results."),
                m(".col-12.d-flex.justify-content-start.align-items-center",
                  m("span.me-3",
                    `${this.getText("LT00000794",
                      "Total Record(s) Inserted"
                    )}: `,
                    m("span.text-success.fw-bold", uploadedResult?.successCount)
                  ),
                  m("span.me-3",
                    `${this.getText("LT00000795",
                      "Total Record(s) Rejected"
                    )}: `,
                    m("span.text-danger.fw-bold", uploadedResult?.errorCount)
                  ),
                  m("button.btn.btn-primary.btn-sm",
                    {
                      onclick: downloadFixtureSKUMap,
                    },
                    m('i.bi.bi-file-earmark-arrow-down-fill'),
                    this.getText("LT00001002", "Download Result")
                  )
                )
              ])
            ),
            m('li.fw-bold.mb-4',
              m('.mb-2', this.getText('LT00000947', 'Result')),
              /* TABLE */
              m(".card",
                m(".card-body",
                  m(".row.mb-2",
                    m(".col-12.d-flex.justify-content-start.align-items-center",
                      m("button.btn.btn-outline-primary.btn-sm.me-2",
                        {
                          onclick: () => {
                            showDeleteDialog("SELECTED");
                          },
                          disabled: selectedFixtureSKUMappingList.length === 0
                        },
                        m("i.bi.bi-trash.me-2"),
                        this.getText("LT00000821", "Delete Selected")
                      ),
                      m("button.btn.btn-outline-danger.btn-sm",
                        {
                          onclick: () => {
                            showDeleteDialog("ALL");
                          },
                          disabled: fixtureSKUMappingList.length === 0
                        },
                        m("i.bi.bi-trash.me-2"),
                        this.getText("LT00000064", "Delete All")
                      )
                    )
                  ),
                  m(".col-12",
                    m(".table-responsive",
                      m("table.table.table-light.table-sm",
                        m("thead", { style: { color: '#000' } },
                          m("tr.align-middle",
                            m("th",
                              m("input", {
                                tabindex: -1,
                                id: SELECT_ALL_CHECKBOX_ID,
                                type: "checkbox",
                                onchange: onCheckAll,
                              })
                            ),
                            m("th", this.getText("LT00000809", "Site ID")),
                            m("th", this.getText("LT00000144", "Site Name")),
                            m("th", this.getText("LT00001197", "Image Name")),
                            m("th", this.getText("LT00001206", "Position")),
                            m("th", this.getText("LT00000748", "Model Code")),
                          )
                        ),
                        m("tbody",
                          fixtureSKUMappingList.length == 0 &&
                          m("tr",
                            { class: "align-middle" },
                            m("td",
                              { colspan: "21" },
                              this.getText(
                                "EM00000141",
                                "No records found."
                              )
                            )
                          ),
                          fixtureSKUMappingList.map((data, index) =>
                            m(`tr.align-middle.cursor-pointer`,
                              {
                                style: { 'font-weight': 'normal' },
                                onclick: (event) => {
                                  // Triggers select only when user click on the cell
                                  if (event.target.localName === "td" && data.editable) {
                                    document
                                      .querySelector(`#${CHECKBOX_NAME}${index}`)
                                      .dispatchEvent(new MouseEvent("click"));
                                  }
                                },
                              },
                              m("td",
                                m("input", {
                                  id: `${CHECKBOX_NAME}${index}`,
                                  type: "checkbox",
                                  tabindex: -1,
                                  name: CHECKBOX_NAME,
                                  onchange: (event) => {
                                    selectRow(event.target.checked, data);
                                  },
                                })
                              ),

                              m("td", m("span.cursor-text", data.siteID)),
                              m("td", m("span.cursor-text", data.siteName)),
                              m("td", m("span.cursor-text", data.fixtureName)),
                              m("td", m("span.cursor-text.text-wrap", data.position)),
                              m("td", m("span.cursor-text", data.modelCode)),
                            )
                          )
                        )
                      )
                    )
                  ),
                  m(".col-12",
                    m(paginationComponent, {
                      currentPage: pagination.pageIndex,
                      pageSize: pagination.pageSize,
                      totalItems: pagination.totalItems,
                      onPageChanged: onPageChanged,
                      onPageSizeChanged: onPageSizeChanged,
                    })
                  )
                )
              )
            ),
          )
        ),
        m('.row',
          m('.col-md-12.gap-2.d-flex.justify-content-center',
            m(
              "button.btn.btn-white[type='button']", { onclick: onGoBack },
              this.getText("LT00001205", "Go Back")
            ),
            m('button.btn.btn-primary[type="button"].px-4.gap-3', { onclick: onGoNext }, this.getText('LT00001204', "Save & Next")),
          )
        ),
        isMsgOpen && m(styledMessageComponent, {
          isOpen: isMsgOpen, extraProps: extraProps, message: msgContent,
          msgType: messageType.CONFIRM, title: msgTitle,
          confirmButtonIntent: Intent.NEGATIVE,
          handleClose: _dialogClosed,
          handleAction: (e) => {
            if (e === "NO") {
              _dialogClosed();
            } else {
              handleDelete();
            }
          }
        }),
        this.getBaseViews()
      ]
    },

  }
}
